/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAuthenticationConstraint } from './UserAuthenticationConstraint';
import {
    UserAuthenticationConstraintFromJSON,
    UserAuthenticationConstraintFromJSONTyped,
    UserAuthenticationConstraintToJSON,
    UserAuthenticationConstraintToJSONTyped,
} from './UserAuthenticationConstraint';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';
import type { AccessRequestApprovalType } from './AccessRequestApprovalType';
import {
    AccessRequestApprovalTypeFromJSON,
    AccessRequestApprovalTypeFromJSONTyped,
    AccessRequestApprovalTypeToJSON,
    AccessRequestApprovalTypeToJSONTyped,
} from './AccessRequestApprovalType';

/**
 * 
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    permissionId?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    shortName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    applicationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    applicationName?: string | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    organizationGroupId?: any | null;
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    usedInRolesCount?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    tags?: string | null;
    /**
     * 
     * @type {UserType}
     * @memberof PermissionResponse
     */
    userType?: UserType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    canBeRequestedByUsers?: boolean;
    /**
     * 
     * @type {UserAuthenticationConstraint}
     * @memberof PermissionResponse
     */
    userAuthenticationConstraint?: UserAuthenticationConstraint;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requireUserOrganizationInMinSide?: boolean | null;
    /**
     * 
     * @type {AccessRequestApprovalType}
     * @memberof PermissionResponse
     */
    accessRequestApprovalType?: AccessRequestApprovalType;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requiresMfa?: boolean;
    /**
     * 
     * @type {any}
     * @memberof PermissionResponse
     */
    accessExpirationId?: any | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponse
     */
    requiresReasonForAsking?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    helpTextReasonField?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    entraSecurityGroupId?: string | null;
}



/**
 * Check if a given object implements the PermissionResponse interface.
 */
export function instanceOfPermissionResponse(value: object): value is PermissionResponse {
    return true;
}

export function PermissionResponseFromJSON(json: any): PermissionResponse {
    return PermissionResponseFromJSONTyped(json, false);
}

export function PermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'permissionId': json['permissionId'] === undefined ? undefined : json['permissionId'] === null ? null : json['permissionId'],
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'shortName': json['shortName'] === undefined ? undefined : json['shortName'] === null ? null : json['shortName'],
        'description': json['description'] === undefined ? undefined : json['description'] === null ? null : json['description'],
        'applicationId': json['applicationId'] === undefined ? undefined : json['applicationId'] === null ? null : json['applicationId'],
        'applicationName': json['applicationName'] === undefined ? undefined : json['applicationName'] === null ? null : json['applicationName'],
        'organizationGroupId': json['organizationGroupId'] === undefined ? undefined : json['organizationGroupId'] === null ? null : json['organizationGroupId'],
        'usedInRolesCount': json['usedInRolesCount'] === undefined ? undefined : json['usedInRolesCount'] === null ? null : json['usedInRolesCount'],
        'tags': json['tags'] === undefined ? undefined : json['tags'] === null ? null : json['tags'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
        'canBeRequestedByUsers': json['canBeRequestedByUsers'] == null ? undefined : json['canBeRequestedByUsers'],
        'userAuthenticationConstraint': json['userAuthenticationConstraint'] == null ? undefined : UserAuthenticationConstraintFromJSON(json['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': json['requireUserOrganizationInMinSide'] === undefined ? undefined : json['requireUserOrganizationInMinSide'] === null ? null : json['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': json['accessRequestApprovalType'] == null ? undefined : AccessRequestApprovalTypeFromJSON(json['accessRequestApprovalType']),
        'requiresMfa': json['requiresMfa'] == null ? undefined : json['requiresMfa'],
        'accessExpirationId': json['accessExpirationId'] === undefined ? undefined : json['accessExpirationId'] === null ? null : json['accessExpirationId'],
        'requiresReasonForAsking': json['requiresReasonForAsking'] == null ? undefined : json['requiresReasonForAsking'],
        'helpTextReasonField': json['helpTextReasonField'] === undefined ? undefined : json['helpTextReasonField'] === null ? null : json['helpTextReasonField'],
        'entraSecurityGroupId': json['entraSecurityGroupId'] === undefined ? undefined : json['entraSecurityGroupId'] === null ? null : json['entraSecurityGroupId'],
    };
}

export function PermissionResponseToJSON(json: any): PermissionResponse {
    return PermissionResponseToJSONTyped(json, false);
}

export function PermissionResponseToJSONTyped(value?: PermissionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'permissionId': value['permissionId'],
        'name': value['name'],
        'shortName': value['shortName'],
        'description': value['description'],
        'applicationId': value['applicationId'],
        'applicationName': value['applicationName'],
        'organizationGroupId': value['organizationGroupId'],
        'usedInRolesCount': value['usedInRolesCount'],
        'tags': value['tags'],
        'userType': UserTypeToJSON(value['userType']),
        'canBeRequestedByUsers': value['canBeRequestedByUsers'],
        'userAuthenticationConstraint': UserAuthenticationConstraintToJSON(value['userAuthenticationConstraint']),
        'requireUserOrganizationInMinSide': value['requireUserOrganizationInMinSide'],
        'accessRequestApprovalType': AccessRequestApprovalTypeToJSON(value['accessRequestApprovalType']),
        'requiresMfa': value['requiresMfa'],
        'accessExpirationId': value['accessExpirationId'],
        'requiresReasonForAsking': value['requiresReasonForAsking'],
        'helpTextReasonField': value['helpTextReasonField'],
        'entraSecurityGroupId': value['entraSecurityGroupId'],
    };
}

